<ng-container *t="let t">
    <form [formGroup]="taxForm" autocomplete="off">
        <div class="row">
            <div class="col-6">
                <tsl-select-autocomplete #countryAutocomplete [tsl-labelText]="'Country'"
                    [tsl-inputPlaceholder]="'Select country...'" [tsl-errorMessage]="translate.get('Invalid country')"
                    [tsl-formControl]="countryControl" [tsl-options]="taxCountries" [tsl-textFieldName]="'country'"
                    [tsl-valueFieldName]="'abbreviation'" (tsl-selectionChanged)="onCountryChange()">
                </tsl-select-autocomplete>
                <tsl-error style="font-size: 12px;" *ngIf="countryControl.hasError('CountrySelected')">
                    <span i18n="@@2740236561190314005" t="2740236561190314005">Select country from the list</span>
                </tsl-error>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <tsl-form-field class="w-100">
                    <tsl-label i18n="@@4bdba95e548029f5b49c6b98a490dc3bf2634e1b" t="4bdba95e548029f5b49c6b98a490dc3bf2634e1b">Name (as shown on your income tax return)</tsl-label>
                    <input tslInput fullWidth shape="round" formControlName="TaxName" name="TaxName"
                        tslTooltipPosition="after"
                        tooltip="Name (as shown on your income tax return). Name is required on this line; do not leave this line blank" i18n-tooltip="@@7329239069948962434" #name tslTooltip="{{ t('7329239069948962434', name) }}" />
                    <tsl-hint align="below" class="max-length-hint">
                        {{ taxNameControl.value?.length || 0 }} / 100
                    </tsl-hint>
                    <tsl-error *ngIf="taxNameControl.errors && (taxNameControl.dirty || taxNameControl.touched)">
                        <span>{{getValidationErrorMessages('Tax Name', taxNameControl)}}</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>
        <div class="row px-3 pb-3">
            <div class="col-12 row">
                <div *ngIf="showUSAFields">
                    <h3 i18n="@@cac50e9e365d405926714f8e7e8cdb9273794db9" t="cac50e9e365d405926714f8e7e8cdb9273794db9">W-9 Details</h3>
                    <label class="label">
                        <span i18n="@@ec1694fe2f0c3798837dc802a333cd77ec607619" t="ec1694fe2f0c3798837dc802a333cd77ec607619">Check appropriate box for federal tax classification of the person
                            whose name is entered on line 1. Check only</span>{{ ' ' }}<strong i18n="@@96a6fba8c1340ded74509a2b85d9656069a69552" t="96a6fba8c1340ded74509a2b85d9656069a69552">one</strong>
                        <span i18n="@@de9d739a71ac00e1cbd7c2d1052ca2f9b9533a6e" t="de9d739a71ac00e1cbd7c2d1052ca2f9b9533a6e"> of the following seven boxes.</span>
                    </label>
                    <tsl-radio-group formControlName="Classification">
                        <div class="row gy-0" *ngIf="classificationControl.errors && classificationControl.touched">
                            <p class="col my-0 tsl-error text-left" *ngIf="classificationControl.errors.required" i18n="@@434f8f6235a970107568236f8a35a307dddd13e0" t="434f8f6235a970107568236f8a35a307dddd13e0">
                                This field is required.
                            </p>
                        </div>
                        <div class="row">
                            <tsl-radio-button class="col" value="I">
                                <span i18n="@@2c1d3d088a3fcd7f5b3db473de1caad7293f7caa" t="2c1d3d088a3fcd7f5b3db473de1caad7293f7caa">Individual/sole proprietor or single-member LLC</span>
                            </tsl-radio-button>
                            <tsl-radio-button class="col" value="C">
                                <span i18n="@@a25a5befda02902a868f8b576a5d86de5f119ccb" t="a25a5befda02902a868f8b576a5d86de5f119ccb">C Corporation</span>
                            </tsl-radio-button>
                            <tsl-radio-button class="col" value="S">
                                <span i18n="@@bb07b4df9d13deeb937666697a96dbbdcf412bfe" t="bb07b4df9d13deeb937666697a96dbbdcf412bfe">S Corporation</span>
                            </tsl-radio-button>
                            <tsl-radio-button class="col" value="P">
                                <span i18n="@@dfceee2c82e4f4566f58b08e788ba25d1b26ad4c" t="dfceee2c82e4f4566f58b08e788ba25d1b26ad4c">Partnership</span>
                            </tsl-radio-button>
                            <tsl-radio-button class="col" value="T">
                                <span i18n="@@5cb9ecac4cd8728470c187195ec964c2be56ed49" t="5cb9ecac4cd8728470c187195ec964c2be56ed49">Trust/estate</span>
                            </tsl-radio-button>
                        </div>
                        <div class="row">
                            <div class="col">
                                <tsl-radio-button value="L">
                                    <span i18n="@@9f4e994b38f2ba4208fd12c87ccec6ac2acb9477" t="9f4e994b38f2ba4208fd12c87ccec6ac2acb9477">Limited liability company</span>
                                </tsl-radio-button>
                            </div>
                            <div class="col" *ngIf="classificationControl.value == 'L'">
                                <tsl-form-field class="w-100">
                                    <tsl-label i18n="@@d81ed2b83d25909abcad7e739e6d61484e09d247" t="d81ed2b83d25909abcad7e739e6d61484e09d247">Tax Classification</tsl-label>
                                    <tsl-select
                                        placeholder="Enter the tax classification (C=C corporation, S=S corporation, P=Partnership)"
                                        tPlaceholder="EnterTheTaxClassification" i18n-placeholder="@@EnterTheTaxClassification"
                                        formControlName="ClassificationType">
                                        <tsl-option value="C" i18n="@@32283d5ae3ade76018e5b092a9a7427a707d78c5" t="32283d5ae3ade76018e5b092a9a7427a707d78c5">C corporation</tsl-option>
                                        <tsl-option value="S" i18n="@@90b74f2a943f6468ba1257dd9bf7aa08dbd87a7b" t="90b74f2a943f6468ba1257dd9bf7aa08dbd87a7b">S corporation</tsl-option>
                                        <tsl-option value="P" i18n="@@25b8ab4dd6a2a95d87d599c9a7cbae9f09e6c8f3" t="25b8ab4dd6a2a95d87d599c9a7cbae9f09e6c8f3">Partnership</tsl-option>
                                    </tsl-select>
                                    <tsl-error
                                        *ngIf="classificationTypeControl.errors && (classificationTypeControl.dirty || classificationTypeControl.touched)">
                                        <span>{{getValidationMessages('Tax Classification', classificationTypeControl)}}</span>
                                    </tsl-error>
                                </tsl-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <tsl-radio-button value="O">
                                    <span i18n="@@c2a9de3714f5767b174d0424bc8abe2dc37acc41" t="c2a9de3714f5767b174d0424bc8abe2dc37acc41">Other</span>
                                </tsl-radio-button>
                            </div>
                            <div class="col" *ngIf="classificationControl.value == 'O'">
                                <tsl-form-field class="w-100">
                                    <tsl-label i18n="@@d148ea60a76f9ae79c96e613f47dde525cb67b3d" t="d148ea60a76f9ae79c96e613f47dde525cb67b3d">Other Company</tsl-label>
                                    <input tslInput fullWidth shape="round" formControlName="OtherCompany"
                                        name="OtherCompany" placeholder="Other Company" tPlaceholder="d148ea60a76f9ae79c96e613f47dde525cb67b3d" i18n-placeholder="@@d148ea60a76f9ae79c96e613f47dde525cb67b3d"/>
                                    <tsl-error
                                        *ngIf="otherCompanyControl.errors && (otherCompanyControl.dirty || otherCompanyControl.touched)">
                                        <span>{{getValidationMessages('Other Company', otherCompanyControl)}}</span>
                                    </tsl-error>
                                </tsl-form-field>
                            </div>
                        </div>
                    </tsl-radio-group>
                </div>
                <div class="row">
                    <div class="row px-3 pb-3" *ngIf="showIndividualOrCorporateQuestion">
                        <div  class="col-10"  style="padding-top: 20px;" [ngClass]="{'error': Domestic_Corporate_Ques_Error }">
                            <tsl-label i18n="@@QACorporateQues" t="QACorporateQues">Please confirm if the Supplier's organization is registered as an individual or company.</tsl-label>
                            <tsl-radio-group formControlName="Domestic_Corporate_Ques">
                                <tsl-radio-button value="Individual" (change)="resetErrorHighlight('Domestic_Corporate_Ques')"><span i18n="@@5942174826323872290" t="5942174826323872290">Individual</span></tsl-radio-button>
                                <tsl-radio-button value="Company" (change)="resetErrorHighlight('Domestic_Corporate_Ques')"><span i18n="@@Company" t="Company">Company</span></tsl-radio-button>
                            </tsl-radio-group>
                            <div *ngIf="taxForm.get('Domestic_Corporate_Ques')?.errors && (taxForm.get('Domestic_Corporate_Ques')?.dirty || taxForm.get('Domestic_Corporate_Ques')?.touched)">
                                <span class="m-0 text-left tsl-error" i18n="@@DomesticCorporateErrorMessage" t="DomesticCorporateErrorMessage">Individual Or Company question is Required</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngIf="showTaxTypes">
                        <div class="col-6">
                            <tsl-form-field class="w-100">
                                <tsl-label i18n="@@3c84249bf801701c7bfbe99c96645d7616081158" t="3c84249bf801701c7bfbe99c96645d7616081158">Tax Types</tsl-label>
                                <tsl-select placeholder="Tax Types" formControlName="TaxIDTypes" tPlaceholder="3c84249bf801701c7bfbe99c96645d7616081158" i18n-placeholder="@@3c84249bf801701c7bfbe99c96645d7616081158"
                                    [disabled]="isTaxIdTypeDisabled">
                                    <tsl-option *ngFor="let option of taxIDtypesByCountry" [value]="option.taxIdType">
                                        {{translate.get(option?.taxIdType)}} - {{translate.get(option?.description)}}
                                    </tsl-option>
                                </tsl-select>
                                <tsl-error
                                    *ngIf="taxIdTypeControl.errors && (taxIdTypeControl.dirty || taxIdTypeControl.touched)">
                                    <span>{{getValidationErrorMessages('Tax Types', taxIdTypeControl)}}</span>
                                </tsl-error>
                            </tsl-form-field>
                        </div>

                        <!-- "USER INPUT FOR THE FULL TAX ID" -->
                        <div class="col-5" *ngIf="!showExistingTaxID()">
                            <tsl-form-field class="w-100">
                                <tsl-label i18n="@@6611342055476246417" t="6611342055476246417">Tax ID</tsl-label>
                                <input tslInput tsl-ssn-mask [tsl-taxType]="taxIdTypeControl.value" fullWidth shape="round"
                                    formControlName="FederalTaxID" name="FederalTaxID" />
                                <tsl-error
                                    *ngIf="taxIdControl.fieldControl.errors && (taxIdControl.fieldControl.dirty || taxIdControl.fieldControl.touched)">
                                    <span>{{getValidationErrorMessages('Tax ID', taxIdControl.fieldControl)}}</span>
                                </tsl-error>
                            </tsl-form-field>
                        </div>

                        <!-- "EAD-ONLY TAX ID WHEN THERE'S AN EXISTING VALUE IN THE BACK END AND WE DISPLAY ONLY THE 4 LAST DIGITS" -->
                        <div class="col-5" *ngIf="showExistingTaxID()">
                            <tsl-form-field class="w-100">
                                <tsl-label i18n="@@6611342055476246417" t="6611342055476246417">Tax ID</tsl-label>
                                <input tslInput type="text" shape="round" readonly
                                    [value]="'*****' + taxIdControl.last4Value" placeholder="Tax ID" fullWidth
                                    name="txtTaxID" tPlaceholder="6611342055476246417" i18n-placeholder="@@6611342055476246417" />
                                <a class="link inline-icon" *ngIf="!readOnly" (click)="editFederalTaxId()"
                                    tooltip="Click to edit tax ID" i18n-tooltip="@@9048071373980503858" #editTaxID tslTooltip="{{ t('9048071373980503858', editTaxID) }}">
                                    <tsl-icon class="input-inline">edit</tsl-icon>
                                </a>
                            </tsl-form-field>
                        </div>

                        <div class="col-12" *ngIf="TaxIdTypeVerbiage != undefined && TaxIdTypeVerbiage != null && TaxIdTypeVerbiage != ''">
                            <tsl-label class="label-text"><span><b i18n="@@c9cf08381074345fa223dbf0868d9310defb46d3" t="c9cf08381074345fa223dbf0868d9310defb46d3">NOTE:</b>{{" "}}{{translate.get(TaxIdTypeVerbiage)}}</span></tsl-label>
                        </div>
                    </ng-container>
                    
                    <!-- READ-ONLY TEXT BOX FOR 1099 -->
                    <div class="col-6" *ngIf="showUSAFields">
                        <tsl-form-field class="w-100">
                            <tsl-label i18n="@@b5c34b5ac6171fd96318ed9d0fa8f7aa671ddca7" t="b5c34b5ac6171fd96318ed9d0fa8f7aa671ddca7">1099 Box</tsl-label>
                            <tsl-select placeholder="1099 Box" formControlName="Tax1099Box" >
                                <tsl-option *ngFor="let taxBox of tax1099BoxesList | sortBy: 'asc'" [value]="taxBox.Name">
                                    {{ taxBox.Name }}-{{ taxBox.Description }}
                                </tsl-option>
                            </tsl-select>
                        </tsl-form-field>
                        <tsl-error *ngIf="tax1099Control.errors && (tax1099Control.dirty || tax1099Control.touched)">
                            <span>1099 Field is required</span>
                        </tsl-error>
                    </div>
                    <div class="col-1 pl-0 pt-3" *ngIf="showUSAFields">
                        <button type="button" tsl-icon-button
                            tooltip="Those who are self-employed receive a 1099 to use for income tax preparation" i18n-tooltip="@@1307160636124095256" #selfEmployedNote tslTooltip="{{ t('1307160636124095256', selfEmployedNote) }}">
                            <tsl-icon class="mat-24">info</tsl-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="showVATNumber">
            <div class="col-6">
                <tsl-form-field class="w-100">
                    <tsl-label i18n="@@1fb1b3d419878b1b104256a6a29723907e959503" t="1fb1b3d419878b1b104256a6a29723907e959503">VAT/Tax No.</tsl-label>
                    <input tslInput fullWidth shape="round" formControlName="VATNumber" name="VATNumber" />
                    <tsl-hint align="below" class="max-length-hint">
                        {{ vatNumberControl.value?.length || 0 }} / 20
                    </tsl-hint>
                    <tsl-error *ngIf="vatNumberControl.errors && (vatNumberControl.dirty || vatNumberControl.touched)">
                        <span>{{getValidationErrorMessages('VAT/Tax No.', vatNumberControl)}}</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>
        <div class="row" *ngIf="showAdditionalTaxTypes">
            <!-- ADDITIONAL TAX ID TYPES -->
            <div class="col-12" *ngIf="showAdditionalTaxTypes">
                <app-taxid-type-display #additionalTaxIdTypesForm  [tsl-configProperties]="configProperties" [tsl-currentSelectedCountry]="selectedCountry" [tsl-taxType]="AdditionalTaxType" [tsl-taxData]="supplierTax"></app-taxid-type-display>
            </div>
        </div>
        <div>
            <div *ngIf="isSchemaAvailable">
                <tsl-accordion class="accordion" [multiple]="true" >
                  <tsl-accordion-group (expandedChange)="onExpansionChange($event)" [expanded]="true">
                    <tsl-accordion-header>
                        <div  class="action-view-accordian">
                            <div>
                                <tsl-accordion-group-title>
                                    <tsl-label><span>WITHHOLDING FORM <tsl-icon [tslTooltip]="withHoldingFormToolTip">info</tsl-icon></span></tsl-label>                      
                                </tsl-accordion-group-title>
                            </div>
                        </div>
                    </tsl-accordion-header>
          
                    <ng-dynamic-form 
                    #withHoldingForm 
                    *ngIf="formSchema" 
                    [formData]="formData" 
                    [formSchema]="formSchema" 
                    [formMaxHeight]="false" 
                    [translationData]="file"
                    (onChangeField)="onWithHoldingFormFieldChangeEvent($event)"
                    >
                    </ng-dynamic-form>
                  </tsl-accordion-group>
                </tsl-accordion>
            </div>
        </div>

        <div class="row padding-view" *ngIf="requiredDocuments?.length>0">
            <div class="col-12">
                <documents-grid #taxDocumentsGrid [tsl-supplierCode]="supplierCode" [tsl-documents]="requiredDocuments"
                  [tsl-optional-documents]="OptionalDocuments"  [tsl-readOnly]="readOnly"></documents-grid>
            </div>
        </div>

        <div class="row px-1 pb-3 padding-view" *ngIf="showW9Verbiage">
            <div class="col-10">
                <label class="label"><b i18n="@@c9cf08381074345fa223dbf0868d9310defb46d3" t="c9cf08381074345fa223dbf0868d9310defb46d3">NOTE:</b>
                    <span i18n="@@b5f66ae6650bec01672c134003a00d52bc084dd6" t="b5f66ae6650bec01672c134003a00d52bc084dd6">If you are a USA Supplier and do not have a W-9 form you may use
                        this link to download one from the IRS website.</span>
                </label>
                <a href="https://www.irs.gov/pub/irs-pdf/fw9.pdf"
                    target="_blank">https://www.irs.gov/pub/irs-pdf/fw9.pdf</a>
            </div>
        </div>
        
        <div class="row px-1 pb-3 padding-view" *ngIf="showW8Verbiage">
            <div class="col-10">
                <label class="label"><b i18n="@@c9cf08381074345fa223dbf0868d9310defb46d3" t="c9cf08381074345fa223dbf0868d9310defb46d3">NOTE:</b>
                    <span i18n="@@5fc2d1880aceff65100f8bea7cb81a781e8eba62" t="5fc2d1880aceff65100f8bea7cb81a781e8eba62">
                        If you are a Non-USA Supplier and do not have a W-8 form you may
                        use this link to download one from the IRS website.
                    </span>
                </label>
                <a href="https://www.irs.gov/forms-pubs/about-form-w-8"
                    target="_blank">https://www.irs.gov/forms-pubs/about-form-w-8</a>
            </div>
        </div>
        <div class="row px-1 pb-3 padding-view" *ngIf="isSelectedCountryJP">
            <div class="col-10">
                <label class="label"><b i18n="@@c9cf08381074345fa223dbf0868d9310defb46d3" t="c9cf08381074345fa223dbf0868d9310defb46d3">NOTE:</b>
                    <span i18n="@@localiseJapanTaxLinkNote" t="localiseJapanTaxLinkNote">
                        If you have a registration number with the National Tax Agency in Japan , you may use the following link to print your organization / company registration number. 
                    </span>
                </label>
                <a href="https://www.invoice-kohyo.nta.go.jp/index.html"
                    target="_blank">https://www.invoice-kohyo.nta.go.jp/index.html</a>
            </div>
        </div>
        <div *ngIf="!hideSaveBtn || !hideCancelButton" [ngClass]="{'row': true, 'footer-view' : isWithHoldingFormApplicable , 'footer-transition': isWithHoldingFormApplicable}">
            <div [ngClass]="{'col-12': true , 'action-view' : isWithHoldingFormApplicable , 'action-view-end': !isWithHoldingFormApplicable  }">
                <div *ngIf="isWithHoldingFormApplicable">
                  <tsl-slide-toggle  [labelPosition]="toggleLablePosition" (change)="accordianViewChange($event , null)">{{actionName}} </tsl-slide-toggle>
                </div>
                <div>
                    <button tsl-button *ngIf="!hideCancelButton" color="black" outline (click)="onCancel()">{{
                        translate.get(cancelBtnText) }}</button>
                    <button *ngIf="!hideSaveBtn" tsl-button (click)="onSubmit()" color="blue" size="medium">{{
                        translate.get(saveBtnText)}}</button>
                </div>
              </div>
        </div>
    </form>
</ng-container>